/**
 * BodyProgram - Main JavaScript
 * Handles FAQ, countdown timers, product page interactions and global cleanup.
 */

document.addEventListener('DOMContentLoaded', () => {
    initFAQ();
    initCountdownTimers();
    initProductPageActions();
    nukeScrollIndicators();
});

// --- FAQ Logic ---
function initFAQ() {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-q');
        const answer = item.querySelector('.faq-a');

        if (!question || !answer) return;

        question.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            faqItems.forEach(other => {
                if (other !== item) other.classList.remove('active');
            });

            item.classList.toggle('active', !isActive);
        });
    });
}

// --- Countdown Timers ---
function initCountdownTimers() {
    const timers = document.querySelectorAll('.countdown-timer');
    if (timers.length === 0) return;

    const SESSION_KEY = 'bp_countdown_end';
    let endTs = sessionStorage.getItem(SESSION_KEY);
    if (!endTs || Date.now() > Number(endTs)) {
        endTs = Date.now() + 24 * 60 * 60 * 1000;
        sessionStorage.setItem(SESSION_KEY, endTs);
    }
    const end = new Date(Number(endTs));

    function update() {
        const current = new Date();
        const diff = end - current;

        if (diff <= 0) {
            timers.forEach(t => t.textContent = '00:00:00');
            return;
        }

        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);

        const str = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
        timers.forEach(t => t.textContent = str);
    }

    setInterval(update, 1000);
    update();
}

// --- Product Page Interactions ---
function initProductPageActions() {
    initQuantityControls();
    initDirectCheckout();
    initMobileStickyATC();
}

function initQuantityControls() {
    document.querySelectorAll('[data-bp-qty-step]').forEach(button => {
        button.addEventListener('click', () => {
            const quantityWrap = button.closest('.qty-inner');
            const input = quantityWrap ? quantityWrap.querySelector('input[name="quantity"]') : null;
            const step = Number(button.dataset.bpQtyStep || 0);

            if (!input || !step) return;

            if (step < 0) {
                input.stepDown();
            } else {
                input.stepUp();
            }

            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });
}

function initDirectCheckout() {
    document.querySelectorAll('[data-bp-direct-checkout]').forEach(button => {
        button.addEventListener('click', async event => {
            event.preventDefault();

            const form = button.closest('form');
            if (!form || button.disabled) return;

            const originalLabel = button.textContent;
            button.disabled = true;
            button.textContent = button.dataset.loadingText || 'Even geduld...';

            try {
                await addProductFormToCart(form);
                window.location.href = '/checkout';
            } catch (error) {
                console.warn('Direct checkout failed, falling back to normal cart add.', error);
                button.disabled = false;
                button.textContent = originalLabel;
                const submitButton = form.querySelector('[type="submit"]');
                if (submitButton) submitButton.click();
            }
        });
    });
}

async function addProductFormToCart(form) {
    const formData = new FormData(form);
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    const endpoint = `${root.replace(/\/$/, '')}/cart/add.js`;

    const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
        headers: {
            Accept: 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Cart add failed with status ${response.status}`);
    }

    return response.json();
}

function initMobileStickyATC() {
    const stickyAtc = document.querySelector('.mobile-sticky-atc');
    const primaryAtc = document.querySelector('[data-bp-product-primary-atc]');

    if (!stickyAtc || !primaryAtc) return;

    let ticking = false;

    const updateStickyState = () => {
        const buttonBottom = primaryAtc.getBoundingClientRect().bottom;
        stickyAtc.classList.toggle('visible', buttonBottom < 0);
        ticking = false;
    };

    const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStickyState);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
}

// --- Scroll Indicator DOM Nuke ---
// Removes any scroll indicator elements injected by apps or Shopify.
function nukeScrollIndicators() {
    const selectors = [
        '.scroll-indicator', '.hero-scroll-indicator', '.mouse-icon',
        '.scroll-pulse', '.scroll-mouse', '.scroll-hint', '.mouse-scroll',
        '.mouse-animation', '.scroll-arrow', '.scroll-down-indicator',
        '#scroll-indicator', '[class*="scroll-indicator"]',
        '[class*="mouse-icon"]', '[class*="scroll-mouse"]'
    ];

    function removeElements() {
        selectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(el => el.remove());
        });
    }

    removeElements();

    if (!document.body) return;

    const observer = new MutationObserver(() => removeElements());
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 8000);
}
